export class MagnifyingGlassComponent {
  _zoom = 2;
  _containerEl;

  constructor(imgEl, container) {
    this._imgEl = imgEl;
    this._containerEl = container;

    this.handleEvent();
  }

  handleEvent() {
    this._imgEl.addEventListener('mouseenter', () => {
        this._imgEl.closest(this._containerEl)
          .querySelectorAll('.img-magnifier-glass')
          .forEach(x => x.remove());

      const glass = document.createElement('div');

      this._imgEl.parentElement.insertBefore(glass, this._imgEl);

      glass.setAttribute('class', 'img-magnifier-glass');
      glass.style.backgroundImage = `url(${ this._imgEl.src })`;
      glass.style.backgroundSize = `${ this._imgEl.width * this._zoom }px ${ this._imgEl.height * this._zoom }px`;

      const borderWidth = parseInt(window.getComputedStyle(glass).getPropertyValue('border-top-width'));
      const w = glass.offsetWidth / 2;
      const h = glass.offsetHeight / 2;

      const params = [glass, w, h, borderWidth, this._zoom];

      glass.addEventListener('mousemove', this.moveMagnifier.bind(this, ...params));
      this._imgEl.addEventListener('mousemove', this.moveMagnifier.bind(this, ...params));

      glass.addEventListener('touchmove', this.moveMagnifier.bind(this, ...params));
      this._imgEl.addEventListener('touchmove', this.moveMagnifier.bind(this, ...params));

      glass.addEventListener('mouseleave', glass.remove);
    });
  }

  moveMagnifier( glass, w, h, borderWidth, zoom, e) {
    e.preventDefault();

    let { x, y } = this.getCursorPos(e);

    if (x > this._imgEl.width - (w / zoom)) {
      x = this._imgEl.width - (w / zoom)
    }

    if (x < w / zoom) {
      x = w / zoom
    }

    if (y > this._imgEl.height - ( h / zoom )) {
      y = this._imgEl.height - ( h / zoom )
    }

    if (y < h / zoom) {
      y = h / zoom
    }

    glass.style.left = `${ x - w }px`;
    glass.style.top = `${ y - h }px`;
    glass.style.backgroundPosition = `-${ (x * zoom) - w + borderWidth }px -${ (y * zoom) - h + borderWidth }px`;
  }

  getCursorPos(e) {
    const imgCoords = this._imgEl.getBoundingClientRect();

    const x = (e.pageX - imgCoords.left) - window.pageXOffset;
    const y = (e.pageY - imgCoords.top) - window.pageYOffset;

    return {
      x: x,
      y: y
    };
  }
}
